import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withUsers } from "src/modules/user/operations";

import { withStateAndActionsForUser } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, users, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"users"}
            component={RenderSelect}
            placeholder={"Users"}
            label={"Users"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(users?.map((user) => ({
                    id: user.id,
                    label: user.name || "",
                    value: JSON.stringify(user),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(withStateAndActionsForUser, withUsers)(SubjectsField);
